import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M20.25 8.516c.884.284 1.5 1.128 1.5 2.097v4.285c0 1.137-.847 2.1-1.98 2.193q-.51.042-1.02.073v3.09l-3-3q-2.031 0-4.02-.163a2.1 2.1 0 0 1-.825-.241m9.345-8.334a2 2 0 0 0-.476-.095 48.6 48.6 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.285c0 .838.46 1.581 1.155 1.952m9.345-8.334V6.642c0-1.621-1.152-3.027-2.76-3.235a48.5 48.5 0 0 0-6.24-.402c-2.115 0-4.198.136-6.24.402-1.608.208-2.76 1.614-2.76 3.235v6.225c0 1.622 1.152 3.027 2.76 3.236a48 48 0 0 0 1.74.194v4.708l4.155-4.155"
    }, null, -1)
  ])))
}
export default { render: render }